import {
  LOGIN_USER,
  LOGOUT_USER,
  SET_GOOGLE_AUTH_STATUS
} from '../actions';

const INIT_STATE = {
  isLoggedIn: !!localStorage.getItem('token'),
  googleAuthStatus: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case LOGIN_USER:
      return {...state, isLoggedIn: true};
    case LOGOUT_USER:
      return {...state, isLoggedIn: false};
    case SET_GOOGLE_AUTH_STATUS:
      return {...state, googleAuthStatus: action.payload};
    default:
      return {...state};
  }
};
